import { parse } from "date-fns";
import React from "react";
import { useTranslation } from "react-i18next";
import Box from "react-raster";
import { DatePicker, Heading, Paper } from "src/components";
import { TimePicker } from "src/components/timePicker/timePicker";
import { theme } from "src/config";
import { Colors } from "src/types";

export const DateSection = (props: any): JSX.Element => {
  const {  data } = props;
  const [date, setDate] = React.useState(0);
  const [time, setTime] = React.useState(data);
  const { t, i18n } = useTranslation();

  return (
      <Box
        colspan={2}
        gridColumnGap={theme.layout.gutterSmall}
        gridRowGap={theme.layout.gutterSmall}
      >
              <Heading weight="normal" type="h3" color="black">Dates</Heading>
        <Box cols={2}>
          <hr />
        </Box>
        <DatePicker
          label="Date"
          value={date}
          onChange={setDate}
          calendarProps={{
            editable: true,
            selectable: true,
            weekNumbers: true,
            handleWindowResize: true
          }}
        />
        <TimePicker
          label="Time"
          cancelLabel={t("cancel")}
          confirmLabel={"OK"}
          value={time}
          onChange={setTime}
        />
      </Box>
  );
};
